// extracted by mini-css-extract-plugin
export default {"scouting-red":"Switch__scouting-red___ZYlmS","large":"Switch__large___Ukf2w"};